import React from "react";
import { Dropdown } from "react-bootstrap";

/**
 * Inline dropdown to select an existing email template (no modal).
 * Used next to "Email Template Edit" in project, proposal, and contact send-email flows.
 */
const TemplateSelectModal = ({ show, onHide, templates = [], onSelect }) => {
  const handleSelect = (template) => {
    onSelect(template);
    if (onHide) onHide();
  };

  if (!templates?.length) return null;

  return (
    <Dropdown align="start" onToggle={(isOpen) => !isOpen && onHide?.()}>
      <Dropdown.Toggle
        variant="link"
        className="p-0 text-decoration-none align-baseline"
        id="template-select-dropdown"
      >
        Change template
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {templates.map((template) => (
          <Dropdown.Item
            key={template.key || template.id}
            onClick={() => handleSelect(template)}
          >
            {template.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TemplateSelectModal;
